export enum BankAccountTypesEnum {
  CUENTA_CORRIENTE = 1,
  CAJA_DE_AHORRO,
}
